import { EDITOR_TYPE } from '@wix/wix-vod-constants/common';
export function getEditorTypeFromLocation() {
  if (typeof window !== 'undefined' && window.location.href.match(/editorx.com/)) {
    return EDITOR_TYPE.EditorX;
  }
  return EDITOR_TYPE.Editor;
}
export function isEditorX() {
  return getEditorTypeFromLocation() === EDITOR_TYPE.EditorX;
}
//# sourceMappingURL=editor-type.js.map